import history from "./history";
import isObjectEmpty from "./isObjectEmpty";

export default function auth() {
  const token: Record<string, any> = JSON.parse(
    localStorage.getItem("token") ?? "{}"
  );

  // Auth is currently checked from render paths. Avoid adding repeated
  // /login entries when those components rerender without a token.
  if (isObjectEmpty(token) && history.location.pathname !== "/login") {
    history.replace("/login");
  }
}
